import type { TourStep } from '../types';

export const productEditSteps: TourStep[] = [
  {
    target: '[data-tour="product-edit-modal"]',
    title: 'Редактирование товара',
    content: 'Здесь вы можете изменить данные существующего товара. Поля с ошибками подсвечены красным — исправьте их перед сохранением.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-edit-title"]',
    title: 'Название товара',
    content: 'Основное название товара. Должно быть уникальным и информативным. Используется на всех маркетплейсах.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-edit-article"]',
    title: 'Артикул',
    content: 'Внутренний код товара. Формат: КАТЕГОРИЯ-ДИЗАЙН (например: CUP-1234). Используется для идентификации товара.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-edit-barcode"]',
    title: 'Баркод',
    content: 'EAN-13 штрихкод. Если поле пустое, баркод будет сгенерирован автоматически. Проверьте уникальность кода.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-edit-composition"]',
    title: 'Состав',
    content: 'Материал товара. Важно для текстиля и товаров с регулируемым составом. Формат: "Материал XX%".',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-edit-dimensions"]',
    title: 'Габариты',
    content: 'Размеры товара и упаковки в миллиметрах. Важно для расчёта стоимости доставки на маркетплейсах.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-edit-weight"]',
    title: 'Вес',
    content: 'Вес нетто (товар) и брутто (с упаковкой) в граммах. Используется для расчёта логистики.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-edit-certificates"]',
    title: 'Сертификаты',
    content: 'Данные о сертификации: номер декларации, сертификата, даты регистрации и окончания действия.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-edit-validation"]',
    title: 'Валидация',
    content: 'Красным подсвечены поля с ошибками. Исправьте их для успешной выгрузки на маркетплейсы.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-edit-save"]',
    title: 'Сохранение',
    content: 'После редактирования нажмите "Сохранить". Изменения применятся немедленно. Статус товара обновится автоматически.',
    placement: 'top',
    disableBeacon: true,
  },
];
